import { imagePlaceholder } from '@tm/client-form/src/misc/imagePlaceholder'
import { useCallback, useMemo } from 'react'
import { useCampaign } from '../../../../hooks/useCampaign'
import { useI18N } from '../../../../hooks/useI18n'
import { ViewProps } from '../types'
import { UsePictureField } from './types'
import { ContactInfoFields } from './useReviewFields'

export function useLogoPictureField(
  { state, dispatch }: Pick<ViewProps, 'state' | 'dispatch'>,
  fields: ContactInfoFields
): UsePictureField {
  const { t } = useI18N()
  const { primaryColor, primaryTextColor } = useCampaign()
  const logoPictureField = useMemo(() => fields.get('companyLogo'), [fields])

  const onLogoPictureChange = useCallback(
    (files: FileList | null) => {
      const [file] = files || []
      dispatch({ type: 'set file', field: { name: 'companyLogo', system: true }, file })
    },
    [dispatch]
  )

  const value = useMemo(
    () =>
      state.getFile({
        name: 'companyLogo',
        system: true,
      }),
    [state]
  )

  const labelKey =
    logoPictureField && 'labelKey' in logoPictureField && logoPictureField.labelKey
      ? logoPictureField.labelKey
      : 'review.companyLogo'
  const label =
    logoPictureField && 'label' in logoPictureField && logoPictureField.label ? logoPictureField.label : t(labelKey)

  return {
    value,
    onChange: onLogoPictureChange,
    label,
    primaryColor,
    primaryTextColor,
    chooseImageButtonText: t('file.chooseImage'),
    imagePlaceholder,
  }
}
